const yup = require("yup");
const vals = ["on", "off"];
module.exports = yup.string().oneOf(vals).required("Please choose an option");
